var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRodRoomIcon = function SvgRodRoomIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.519,
    height: 48.519,
    viewBox: "0 0 48.519 48.519"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "rod-room-icon_svg__a",
    width: 48.519,
    height: 48.519,
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rod Room"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#rod-room-icon_svg__a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 251",
    style: {
      fill: "#18252a",
      stroke: "#fff"
    },
    transform: "rotate(-1 435.406 -570.448)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    stroke: "none",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14.5,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M5.662 7h-4v4h4zm-4 9h9v-4h-9zm10 0h4v-4h-4zm-5-9v4h9V7z",
    "data-name": "Secondary Layer",
    style: {
      opacity: 0.5,
      fill: "#fff"
    },
    transform: "translate(15.797 12.143)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8-9a1 1 0 0 0 1 1H7a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1H-7a1 1 0 0 0-1 1z",
    "data-name": "Primary Layer",
    style: {
      fill: "#fff"
    },
    transform: "translate(24.459 26.143)"
  })));
};
export { SvgRodRoomIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OC41MTkiIGhlaWdodD0iNDguNTE5IiB2aWV3Qm94PSIwIDAgNDguNTE5IDQ4LjUxOSI+CiAgICA8ZGVmcz4KICAgICAgICA8ZmlsdGVyIGlkPSIyMmsxaHA4NXBhIiB4PSIwIiB5PSIwIiB3aWR0aD0iNDguNTE5IiBoZWlnaHQ9IjQ4LjUxOSIgZmlsdGVyVW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KICAgICAgICAgICAgPGZlT2Zmc2V0IGR5PSIzIi8+CiAgICAgICAgICAgIDxmZUdhdXNzaWFuQmx1ciBzdGREZXZpYXRpb249IjMiIHJlc3VsdD0iYmx1ciIvPgogICAgICAgICAgICA8ZmVGbG9vZCBmbG9vZC1vcGFjaXR5PSIuMTYxIi8+CiAgICAgICAgICAgIDxmZUNvbXBvc2l0ZSBvcGVyYXRvcj0iaW4iIGluMj0iYmx1ciIvPgogICAgICAgICAgICA8ZmVDb21wb3NpdGUgaW49IlNvdXJjZUdyYXBoaWMiLz4KICAgICAgICA8L2ZpbHRlcj4KICAgIDwvZGVmcz4KICAgIDxnIGRhdGEtbmFtZT0iUm9kIFJvb20iPgogICAgICAgIDxnIHN0eWxlPSJmaWx0ZXI6dXJsKCMyMmsxaHA4NXBhKSI+CiAgICAgICAgICAgIDxnIGRhdGEtbmFtZT0iRWxsaXBzZSAyNTEiIHRyYW5zZm9ybT0icm90YXRlKC0xIDQzNS40MDYgLTU3MC40NDgpIiBzdHlsZT0iZmlsbDojMTgyNTJhO3N0cm9rZTojZmZmIj4KICAgICAgICAgICAgICAgIDxjaXJjbGUgY3g9IjE0IiBjeT0iMTQiIHI9IjE0IiBzdHlsZT0ic3Ryb2tlOm5vbmUiLz4KICAgICAgICAgICAgICAgIDxjaXJjbGUgY3g9IjE0IiBjeT0iMTQiIHI9IjE0LjUiIHN0eWxlPSJmaWxsOm5vbmUiLz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgICAgICA8cGF0aCBkYXRhLW5hbWU9IlNlY29uZGFyeSBMYXllciIgZD0iTTUuNjYyIDdoLTR2NGg0em0tNCA5aDl2LTRoLTl6bTEwIDBoNHYtNGgtNHptLTUtOXY0aDlWN3oiIHN0eWxlPSJvcGFjaXR5Oi41O2ZpbGw6I2ZmZiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTUuNzk3IDEyLjE0MykiLz4KICAgICAgICA8cGF0aCBkYXRhLW5hbWU9IlByaW1hcnkgTGF5ZXIiIGQ9Ik0tOC05YTEgMSAwIDAgMCAxIDFIN2ExIDEgMCAwIDAgMS0xdi00YTEgMSAwIDAgMC0xLTFILTdhMSAxIDAgMCAwLTEgMXoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI0LjQ1OSAyNi4xNDMpIiBzdHlsZT0iZmlsbDojZmZmIi8+CiAgICA8L2c+Cjwvc3ZnPgo=";